import SecurityIcon from '@mui/icons-material/Security';
import {Typography} from '@mui/material';
import Grid from '@mui/material/Grid';

const ReportPrivacyAlert = () => {
  return (
    <Grid
      container
      data-testid="report-privacy"
      gap={1}
      py={2}
      px={3}
      alignItems="flex-start"
      flexWrap="nowrap"
      sx={{
        background: '#F9FAFB',
        color: 'text.secondary',
        borderTop: '1px solid lightgrey'
      }}
    >
      <SecurityIcon color="primary" fontSize="small" />
      <Typography fontSize={12.5} sx={{pr: 2}}>
        Vos données sont traitées de manière sécurisée sur nos serveurs européens, dans la stricte limite nécessaire au fonctionnement du service. Les résumés texte et audio générés respectent les
        principes de minimisation et de licéité exigés par le RGPD.{' '}
        <a target="_blank" href="https://www.drivn.fr/politique-de-confidentialite/" rel="noreferrer">
          En savoir plus
        </a>
      </Typography>
    </Grid>
  );
};

export default ReportPrivacyAlert;
